import { Logo } from '@/components/Logo';
import type { Me } from '@/types/me';
import { MobileDrawer } from './MobileDrawer';
import type { NavItem } from './nav-items';
import { TimerIndicatorSlot } from './TimerIndicatorSlot';

interface MobileHeaderProps {
  items: NavItem[];
  me: Me | undefined;
}

/** Below lg: slim header with the Logo, the running-timer indicator and the hamburger (no page title). */
export function MobileHeader({ items, me }: MobileHeaderProps): JSX.Element {
  return (
    <header className="fixed inset-x-0 top-0 z-30 flex h-12 items-center justify-between gap-2 border-b border-border bg-card px-4 lg:hidden">
      <Logo className="min-w-0" />
      <div className="flex min-w-0 items-center gap-1">
        <TimerIndicatorSlot variant="header" />
        <MobileDrawer items={items} me={me} />
      </div>
    </header>
  );
}
